import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import s from 'base/bolt/boltApp.sss';
import Store from 'store/store';
import { accessNested } from 'utils/utils';

export default class BoltApp extends BaseComp.default {
	render(...args) {
		let base = super.render(...args);
		// Try to avoid flash of unstyled content
		base.attributes = base.attributes || {};
		base.attributes.style = base.attributes.style || {};
		if (typeof base.attributes.style === 'string') {
			base.attributes.style += '; display: none;';
		} else {
			base.attributes.style.display = 'none';
		}
		if (typeof window !== 'undefined') {
			// Once both the CSS and JS are loaded, start showing things
			base.attributes.class += ' ' + s.show;
		}
		return base;
	}
}
